module.exports = __webpack_public_path__ + "img/13.21f0f944.png";